import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { IAssignProductAttributesToProductModel, IAttributes, ICommonAttributePostRequestModel, ICommonAttributePostResponseModel, IMeasurements } from "../../models/product/dto/attributes/product-attributes.model";

@Injectable({
    providedIn: 'root'
})
export class ProductAttributesService {
    fullPath: string;
    unsavedChangesOnAttributesTab = new BehaviorSubject<boolean | undefined>(undefined);
    unsavedChangesOnAttributesTabObs = this.unsavedChangesOnAttributesTab.asObservable();

    constructor(
        private readonly httpClient: HttpClient, 
        public envService: EnvironmentService
    ) {
        this.fullPath = `${envService.settings.apiUrl}`;
    }

    public getCommonAttributes(): Observable<IAttributes[]> {
        return this.httpClient.get<IAttributes[]>(`${this.fullPath}/Options/attributes`);
    }

    public getProductAttributes(productId: number, includeOptions: boolean): Observable<IAttributes[]> {
        return this.httpClient.get<IAttributes[]>(`${this.fullPath}/Products/${productId}/attributes?includeOptions=${includeOptions}`);
    }

    public createCommonAttribute(model: ICommonAttributePostRequestModel): Observable<ICommonAttributePostResponseModel> {
        return this.httpClient.post<ICommonAttributePostResponseModel>(`${this.fullPath}/Products/commonAttributes`, model);
    }

    public updateProductAttributes(model: IAssignProductAttributesToProductModel): Observable<IAttributes[]> {
        return this.httpClient.put<IAttributes[]>(`${this.fullPath}/Products/${model.productId}/attributes`, model);
    }

    getMeasurments(): Observable<IMeasurements[]> {
        return this.httpClient.get<IMeasurements[]>(`${this.fullPath}/Options/unitOfMeasurement`);
    }

    setUnsavedChangesOnAttributesTabStatus(unsavedChanges: boolean) {
        this.unsavedChangesOnAttributesTab.next(unsavedChanges);
    }
}